import { render, staticRenderFns } from "./associationDetail.vue?vue&type=template&id=5956d021&scoped=true"
import script from "./associationDetail.vue?vue&type=script&lang=js"
export * from "./associationDetail.vue?vue&type=script&lang=js"
import style0 from "./associationDetail.vue?vue&type=style&index=0&id=5956d021&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5956d021",
  null
  
)

export default component.exports